/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S3_Platform_BodyInputs */

const tr_mesafeli_s3_platform_body = /** @type {(inputs: Mesafeli_S3_Platform_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`shoppanel.emonse.com adresinden sunulan SaaS yazılım hizmeti.`)
};

const en_mesafeli_s3_platform_body = /** @type {(inputs: Mesafeli_S3_Platform_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SaaS software service provided at the address shoppanel.emonse.com.`)
};

const de_mesafeli_s3_platform_body = /** @type {(inputs: Mesafeli_S3_Platform_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SaaS-Softwaredienst, der unter der Adresse shoppanel.emonse.com bereitgestellt wird.`)
};

const ru_mesafeli_s3_platform_body = /** @type {(inputs: Mesafeli_S3_Platform_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Программная услуга SaaS, предоставляемая по адресу shoppanel.emonse.com.`)
};

/**
* | output |
* | --- |
* | "SaaS software service provided at the address shoppanel.emonse.com." |
*
* @param {Mesafeli_S3_Platform_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s3_platform_body = /** @type {((inputs?: Mesafeli_S3_Platform_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S3_Platform_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s3_platform_body(inputs)
	if (locale === "de") return de_mesafeli_s3_platform_body(inputs)
	if (locale === "ru") return ru_mesafeli_s3_platform_body(inputs)
	return tr_mesafeli_s3_platform_body(inputs)
});